import type { BackupHealth } from '@anytracker/core'

/**
 * When the last backup was taken, in the fewest words that are still true.
 *
 * Only elapsed time. Never "safe", never "protected": a backup file that
 * exists says nothing about whether the data on this device will survive, and
 * the words here sit beside a shield-shaped tile (see `useBackupHealth`).
 */
export function lastBackupShort(health: BackupHealth): string {
  if (!health.everBackedUp) {
    return 'Never'
  }
  if (health.daysSince === 0) {
    return 'Today'
  }
  return health.daysSince === 1 ? '1 day ago' : `${String(health.daysSince)} days ago`
}

/** The same fact as a heading: "Backed up 3 days ago", "Never backed up". */
export function lastBackupHeading(health: BackupHealth): string {
  if (!health.everBackedUp) {
    return 'Never backed up'
  }
  if (health.daysSince === 0) {
    return 'Backed up today'
  }
  return `Backed up ${lastBackupShort(health)}`
}
